import { render } from "./ClinicConfigurationTab.vue?vue&type=template&id=ae83125a&scoped=true"
import script from "./ClinicConfigurationTab.js?vue&type=script&lang=js&external"
export * from "./ClinicConfigurationTab.js?vue&type=script&lang=js&external"

import "./ClinicConfigurationTab.vue?vue&type=style&index=0&id=ae83125a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae83125a"]])

export default __exports__